export default class SiteFooter extends HTMLElement {
    connectedCallback() {
        this.querySelectorAll('.part-main .title').forEach(title => {
            title.addEventListener('click', () => {
                const col = title.closest('[class*="col-"]');
                col.classList.toggle('opened');
            });
        });
    }
}
